/* AnnMichell 2026: prices in the shopper's chosen currency, without an ISO code ("$125.00", "€115.24").
   The 2026 cards print <span class="am-money" data-am-money="12500">$125.00</span> (cents in the shop currency) and NOT
   span.money: the Kilatech Currency Converter on this shop is set to KTCurrency.format = 'money_with_currency_format',
   so every span.money it converts gets " USD" / " EUR" appended. This script converts our prices with Kilatech's own
   rates and its money_format (no code) whenever the currency changes (its dropdown, the header chip, its geo-detect).
   It also converts the PDP price lines ([data-amp-price] / [data-amp-afterpay] .money in sections/am-product.liquid),
   which Kilatech skips because they are <b>/<s>, not span.money, and the "Others also bought" prices
   (sections/am-pdp-recs.liquid, bare "$75.00" text). Untouched while the shop currency is selected. */
(function (W, d) {
  if (W.__am26Money) return;
  W.__am26Money = 1;
  var SEL = '[data-am-money], [data-amp-price] .money, [data-amp-afterpay] .money, .amr__price > b, .amr__price > s';
  var RX = /^\s*\$\s*([\d,]+)(?:\.(\d{1,2}))?\s*(?:USD)?\s*$/;
  var dec = d.createElement('textarea'), raf = 0, wrapped = false;
  function shop() { return W.shopCurrency || W.shop_currency || 'USD'; }
  function K() {
    var k = W.KTCurrency;
    return k && k.rates && k.moneyFormats && typeof k.convert === 'function' && typeof k.formatMoney === 'function' ? k : null;
  }
  function round(e) {
    var D = W.dropdown_CC_KT, mode = D && D.CC_KT_Round, vals = (D && D.CC_KT_Round_Values) || [0, 50, 99];
    if (mode === 'gdecimal') return Math.round(e / 10) * 10;
    if (mode === 'nodecimal') return Math.round(e / 100) * 100;
    if (mode === 'adecimal') {
      var last = e % 100, r = Math.round(e / 100);
      if (last === 0) return e;
      return r * 100 + (last < 30 ? vals[0] : last < 70 ? vals[1] : vals[2]);
    }
    return e;
  }
  function fmt(k, cents, cur) {
    var s = shop(), c = cents;
    if (cur !== s) c = round(Math.round(k.convert(cents, s, cur)));
    var f = (k.moneyFormats[cur] || {}).money_format || (k.moneyFormats[s] || {}).money_format || '${{amount}}';
    dec.innerHTML = k.formatMoney(c, f);
    return dec.value;
  }
  function run() {
    raf = 0;
    var k = K(); if (!k) return;
    var cur = k.currentCurrency || shop(), s = shop();
    if (!k.moneyFormats[cur] || !k.rates[cur]) cur = s;
    var els = d.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i], own = el.getAttribute('data-am-txt'), txt = el.textContent, b;
      if (el.hasAttribute('data-am-money')) {
        b = parseInt(el.getAttribute('data-am-money'), 10);
      } else if (own === null || txt !== own) {
        // never converted, or rewritten by the page (PDP variant switch prints shop-currency text again)
        var m = RX.exec(txt); if (!m) continue;
        b = parseInt(m[1].replace(/,/g, ''), 10) * 100 + (m[2] ? parseInt((m[2] + '0').slice(0, 2), 10) : 0);
        el.setAttribute('data-am-base', b);
        own = null;
      } else {
        b = parseInt(el.getAttribute('data-am-base'), 10);
      }
      if (isNaN(b)) continue;
      if (own === null && cur === s) continue;                         // server text is already the shop currency
      if (own !== null && txt === own && el.getAttribute('data-am-cur') === cur) continue;
      var out = fmt(k, b, cur);
      if (out !== txt) el.textContent = out;
      el.setAttribute('data-am-txt', out);
      el.setAttribute('data-am-cur', cur);
    }
  }
  function queue() { if (!raf) raf = (W.requestAnimationFrame || setTimeout)(run); }
  function wrap(k) {
    if (wrapped || typeof k.convertAll !== 'function') return;
    var orig = k.convertAll;
    k.convertAll = function () { var r = orig.apply(this, arguments); queue(); return r; };
    wrapped = true;
  }
  function start() {
    (function wait(n) {
      var k = K();
      if (k && k.currentCurrency) { wrap(k); run(); return; }
      if (n > 0) setTimeout(function () { wait(n - 1); }, 300);
    })(40);
    if ('MutationObserver' in W) {
      // cards added later (Show more, search results, recommendations) or a PDP price rewrite: only matters off the shop currency
      new MutationObserver(function () {
        var k = K(); if (k && k.currentCurrency && k.currentCurrency !== shop()) queue();
      }).observe(d.body, { childList: true, subtree: true, characterData: true });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
